<template>
    <section class="callback">
        <div class="callback__left">
            <h2>Обратная связь</h2>
          <form action="" :name="'callback'" @submit="sendForm">
            <div class="row">
              <div class="col d12">
                <AInput static-label
                        placeholder="Заголовок"
                        label="ФИО"
                        v-model="fullName"
                        required
                        :class="!validFullName ? 'error' : ''"
                />
              </div>
            </div>
            <div class="row">
              <div class="col d6">
                <AInput static-label
                        placeholder="+ХХ ХХХ ХХ ХХ ХХ"
                        label="Телефон"
                        type="tel"
                        v-model="phone"
                        required
                        :class="!validPhone ? 'error' : ''"
                />
              </div>
              <div class="col d6">
                <AInput static-label
                        placeholder="example@example.com"
                        label="Email"
                        type="email"
                        v-model="email"
                        required
                        :class="!validEmail ? 'error' : ''"
                />
              </div>
            </div>
            <div class="row">
              <div class="col d12">
                <AInput static-label
                        placeholder="Введите текст"
                        label="Ваш вопрос"
                        type="textarea"
                        v-model="question"
                        required
                        :class="!validQuestion ? 'error' : ''"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <ACheckbox label="Ознакомлен с правилами обработки персональных данных"
                           v-model="agreement"/>
              </div>
            </div>
            <div class="row mb-3" v-if="ajaxOk">
              <div class="col okText">Форма успешно отправлена!</div>
            </div>
            <div class="row mb-3" v-if="ajaxErrors.length">
              <div class="col d12 errorText" v-for="error in ajaxErrors">
                {{ error }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <ABtn :label="'Задать вопрос'"
                      :disabled="!validForm"
                      type="submit"
                      class="primary submitBtn"/>
              </div>
            </div>
          </form>
        </div>
        <div class="callback__right">
            <h3>Возникли вопросы?</h3>
            <p>Напишите нам и наша команда ответит вам как можно скорее</p>
            <div class="review__author">
                <div class="review__author-avatar"><img
                    src="/local/templates/main/img/content/users/user-1.jpg" alt="Сергей Брин">
                </div>
                <div class="review__info">
                    <span class="review__author-name mr-1">Данара Карсакбаева</span>
                    <br>
                    <span class="review__author-position">Волонтер</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {ref} from 'vue'
import {AChip, ABtn, AInput, ASelect, ADatePicker, ACheckbox, ABadge} from '~/components/ui'
import Map from "../components/Map";
import { required, isEmail, isPhone } from '../libs/Validators'

export default {
  name: "ContactsPageContainer",
  components: {Map, AChip, ABtn, AInput, ASelect, ADatePicker, ACheckbox, ABadge},
  data() {
    return {
      fields: ['fullName', 'email', 'phone', 'question'],

      fullName: '',
      phone: '',
      email: '',
      question: '',

      agreement: false,

      validFullName: true,
      validEmail: true,
      validPhone: true,
      validQuestion: true,
      validForm: false,

      handler: '/ajax/contactsform.php',
      ajaxOk: false,
      ajaxErrors: []
    }
  },
  watch: {
    fullName(value){
      this.validFullName = required(value);
    },
    phone(value){
      this.validPhone = isPhone(value);
    },
    email(value){
      this.validEmail = isEmail(value);
    },
    question(value){
      this.validQuestion = required(value);
    },
    agreement(value){
      this.agreement = value;
      this.validateForm()
    }
  },
  methods: {
    validateForm() {
      this.validForm = this.validFullName && this.validEmail && this.validPhone && this.validQuestion && this.agreement;
    },
    sendForm(e) {
      e.preventDefault()

      this.validateForm();

      let formData = {
        'fullName': this.fullName,
        'phone': this.phone,
        'email': this.email,
        'question': this.question
      };

      fetch(this.handler, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(formData)
      }).then((response) => {
        if(response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        if (json.result === true) {
          this.ajaxOk = true
          this.ajaxErrors = []
        }
        if (json.errors.length) {
          this.ajaxErrors = json.errors
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  }
}
</script>

<style scoped lang="scss">
.errorText {
  color: var(--c-danger);
}
.okText {
  color: var(--c-primary-100);
}
.callback {
  display: flex;
  gap: rem(150);
  padding: rem(120) 0;

  @include tablet {
    flex-direction: column;
    gap: rem(110);
    padding: 0 0 rem(50);
  }

  > div {
    flex: 1;
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include tablet {
      display: none;
    }
  }
}

.submitBtn{
  width: 420px;

  @include tablet {
    width: 100%;
  }
}

::v-deep .Map {
  @include tablet {
    max-height: 300px;
  }

  @include mobile {
    max-height: unset;
  }
}
</style>